import React from "react";
import { useAuth } from "@/lib/auth";
import { roleLabel } from "@/lib/rolePolicy";
import { useI18n } from "@/i18n";

export default function AccountHome() {
  const { user } = useAuth();
  const { t } = useI18n();
  const name = user?.user?.full_name || "an EduOS user";
  return (
    <div className="max-w-3xl mx-auto p-6 md:p-10" data-testid="account-home">
      <h1 className="font-display text-3xl font-bold text-[var(--text-primary)]">{t("account.title")}</h1>
      <p className="mt-2 text-[var(--text-secondary)]">{t("account.signedInAs", { name })}</p>
      <div className="mt-6 rounded-md border border-[var(--subtle)] bg-white p-5">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--text-muted)]">{t("account.recognizedRoles")}</div>
        <div className="mt-2 flex flex-wrap gap-2">
          {(user?.roles || []).map((role) => (
            <span key={role} className="rounded-full bg-[var(--bg)] px-3 py-1 text-sm font-medium">
              {t(`roles.${role}`) === `roles.${role}` ? roleLabel(role) : t(`roles.${role}`)}
            </span>
          ))}
        </div>
        <p className="mt-5 text-sm text-[var(--text-secondary)]">
          {t("account.permissionNotice")}
        </p>
      </div>
    </div>
  );
}
